import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {
  FormControl,
  FormGroup,
} from '@angular/forms';
import { LoadingController, ModalController } from '@ionic/angular';
import { CreateApplication } from '../../core/model/application.model';
import { ApplicationService } from '../../services/application/application.service';
import { DropdownService } from '../../services/dropdown/dropdown.service';
import { Errors, validationType } from '../../core/model/error.model';
import { CommonService } from '../../services/common/common.service';
import { UserService } from '../../services/user/user.service';
import { User } from '../../core/model/user.model';
import { OopsModalComponent } from '../oops-modal/oops-modal.component';
import { nonkycModelComponent } from '../non-kyc-modal/non-kyc-model.component'
import { InvestorType, PanType } from 'src/app/core/constants/enum';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
// import { parse } from 'path';
import { formatDate } from '@angular/common';

@Component({
  selector: 'track-application',
  templateUrl: './track-application.component.html',
  styleUrls: ['./track-application.component.scss'],
})
export class TrackApplicationComponent implements OnInit {
  @Output() success: EventEmitter<any> = new EventEmitter();

  //#region Not needed yet
  @Input() errorMessage: string
  @Input() applicationNo: string;
  @Input() applicationStatus: string;
  @Input() statusLogs: any;
  //#endregion

  @Input() applicationDetails: any;

  applicantForm: FormGroup;
  floatLabelControl = new FormControl('always');
  status: boolean = false;
  error = Errors;
  showLoader = false;
  headerText = ''; //HEADER_TEXT_PANCHECK;
  messageText = ''; //MESSAGE_TEXT_PANCHECK;
  parentFund: any;
  childFund: any;
  RmName: [{ name: 'Jinal' }];
  distributorDetails: any;
  todayDate = new Date();
  NonCkycPopup: boolean = false;
  investorType = InvestorType;
  panType = PanType;
  formId;
  appStatus;
  logs;
  constructor(
    // private readonly userService: UserService,
    private modalController: ModalController,
    private readonly commonService: CommonService,
    private readonly dropdownService: DropdownService,
    private readonly applicationService: ApplicationService,
    private readonly loadingController: LoadingController,
    private userService: UserService,
    private toastController: ToastController,
    private router: Router
  ) { }

  ngOnInit() {
    this.formId = this.applicationNo;
    this.appStatus = this.applicationStatus;
    this.logs = this.statusLogs;
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  getOwner(): string {
    if (!this.applicationDetails) return ''

    if ([this.applicationDetails.buyerFolio, this.applicationDetails.verification_RTA].includes('Pending')) return 'RTA';
    if ([this.applicationDetails.submitted, this.applicationDetails.esign_Pending, this.applicationDetails.diS_Upload,].includes('Pending')) return 'CXO/RM';
    if ([this.applicationDetails.verification_IR, this.applicationDetails.diS_Executed,].includes('Pending')) return 'IR';
    if ([this.applicationDetails.esign].includes("Pending")) return "Investor";
  }

  getCurrentStatus(): string {
    if (this.applicationDetails.buyerFolio === 'Pending') return 'Folio Allocation Pending';
    if (this.applicationDetails.verification_RTA === 'Pending') return 'Pending RTA Verification';
    if (this.applicationDetails.submitted === 'Pending') return 'Application Submitted'
    if (this.applicationDetails.esign_Pending === 'Pending') return 'Esign Pending';
    if (this.applicationDetails.diS_Upload === 'Pending') return 'DIS Upload Pending';
    if (this.applicationDetails.verification_IR === 'Pending') return 'Pending IR Verification';
    if (this.applicationDetails.diS_Executed === 'Pending') return 'Pending DIS Execution';
    if (this.applicationDetails.esign === 'Pending') return 'Esigning from Investor';
    return 'Transaction Completed'
  }
}
